import Vue from 'vue'
import AppStudyBar from '@/components/common/AppStudyBar.vue'

/**
 * Global component registration. Register common components here
 * so they are available to all components and do not need to be explicitly
 * imported.
 */
Vue.component('app-study-bar', AppStudyBar)
